<template>
  <div class="lift-edit">
    <form class="form-horizontal">
      <div class="form-group" style='align:left'>
          <label class="control-label col-sm-2">MAC</label>
          <div class="col-sm-8" id='app_name'>
              <input type="text" name="mac" id="mac" readonly v-model="mac" class="form-control" />
          </div>
      </div>

      <div class="form-group" style='align:left'>
          <label class="control-label col-sm-2">描述</label>
          <div class="col-sm-8">
              <textarea name="desc" id="desc" readonly v-model="desc" class="form-control"></textarea>
          </div>
      </div>

      <div class="form-group" style='align:left'>
          <label class="control-label col-sm-2">安装位置</label>
          <div class="col-sm-8">
            <div style="display:none" id="select-input">
            <select @change="test($event)" class="your-selector form-control">
              <option value=""> - </option>
              <option v-for="addr in level1Addrs" :value="addr.addr_id">{{addr.description}}</option>
            </select>
            </div>
            <span class="addr-span">{{addrLabel(addrs)}}</span>
            <span id="new-addr-span"></span>
            <button type="button" id="btn-edit" class="btn green small pull-right" @click="edit">
              <i class="fa fa-edit"></i>
            </button>
            <div id="btn-ctrl" style="text-align:center;display:none;margin-top: 2px;">
              <button type="button" id="btn-edit" class="btn green small" @click="ensure">
                <i class="fa fa-save"></i>
              </button>
              <button type="button" id="btn-edit" class="btn grey small" @click="discard">
                <i class="fa fa-remove"></i>
              </button>
            </div>
          </div>
      </div>
      <div class="form-group" style='align:left'>
          <label class="control-label col-sm-2">安装时间</label>
          <div class="col-sm-8">
              <p class="form-control-static">{{createTimeStr}}</p>
          </div>
      </div>

      <div class="form-group" style='align:left'>
          <label class="control-label col-sm-2">楼层</label>
          <div class="col-sm-10">
            <table class="table table-bordered table-condensed">
              <tbody>
                <template v-for="item in floorGroup">
                  <tr>
                    <th v-for="it in item">{{it.io_index}}</th>
                  </tr>
                  <tr>
                    <td v-for="it in item">{{it.label}}</td>
                  </tr>
                </template>
              </tbody>
            </table>

              
          </div>
      </div>

      <div class="animated alert alert-danger" id="tip-alert" style="text-align:center;" v-show="isError" role="alert">数据填写不完整！</div>
      <div style="text-align:center">
        <button type='button' class="btn" aria-hidden="true" @click="cancel">返回</button>
        <button type='button' class="btn blue btn-primary" @click="save">确定</button>
      </div>
    </form>
  </div>
</template>

<script>
import http from '../lib/utils/request.js'
import {MSG_ID, SER_RESP_CODE} from '../lib/constant.js'
import mixins from '../mixins/index'
import commonMethods from '../lib/methods/common.js'

export default {
  name: 'lift-edit',
  mixins: mixins,
  data () {
    return {
      id: 0,
      mac: '',
      desc: '',
      addrId: '',
      addrs: [],
      floorGroup: [],
      level1Addrs: [],
      oldAddrId: '',
      createTime: '',
      isError: false,
      // 列表分页用数据
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0
    }
  },
  mounted () {
  },
  methods: {
    cancel () {
      window.emitter.emit(MSG_ID.MSG_UI_HIDE_MODAL)
    },
    get () {
      let reqdata = {id: this.id, page_index: 1, page_size: 1}
      http.invoke('lift.pageLift', reqdata, (data) => {
        let detail = data.content && data.content[0]
        if (detail) {
          this.mac = detail.visitor_mac
          this.desc = detail.description
          this.addrId = detail.addr_id
          this.oldAddrId = detail.addr_id
          this.addrs = detail.addrs
          this.createTime = detail.create_time
          console.log(detail.floors)
          if (detail.floors) {
            if (detail.floors.length > 16) {
              for (let i = 0; i < detail.floors.length; i += 16) {
                this.floorGroup.push(detail.floors.slice(i, i + 16))
              }
            } else {
              this.floorGroup[0] = detail.floors
            }
          }
        }
      })
    },
    edit () {
      window.$('.addr-span').hide()
      window.$('#btn-edit').hide()
      window.$('#btn-ctrl').show()
      window.$('#new-addr-span').html('')
      let reqdata = {parent_addr_id: '0', page_index: 1, page_size: 500}
      http.invoke('addr.pageAddr', reqdata, (data0) => {
        this.level1Addrs = data0.content
        window.$('#select-input').show()
      })
    },
    save () {
      if (!this.id || !this.mac || !this.addrId) {
        this.isError = true
        window.$(this.$el).find('#tip-alert').addClass('shake').removeClass('fadeOut')
        window.setTimeout(() => {
          window.$(this.$el).find('#tip-alert').removeClass('shake').addClass('fadeOut')
          window.setTimeout(() => {
            this.isError = false
          }, 1000)
        }, 2000)
        return
      }
      let reqdata = {addr_id: this.addrId, id: this.id}
      http.invoke('lift.update', reqdata, (data) => {
        window.emitter.emit(MSG_ID.MSG_UI_HIDE_MODAL)
        window.emitter.emit(MSG_ID.MSG_LOCK_REFRESH)
        window.emitter.emit(MSG_ID.MSG_UI_TOAST_SUCC, '操作成功')
      }, (state) => {
        if (state.code !== 2000000) {
          window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, SER_RESP_CODE[state.code])
          return
        }
        switch (state.result) {
          default:
            break
        }
      })
    },
    reset () {
      this.id = 0
      this.mac = ''
      this.desc = ''
      this.addrId = ''
      this.createTime = ''
      this.floorGroup = []
    },
    onShowInModal (options) {
      this.reset()
      if (options.id) {
        this.id = options.id
        this.get()
      }
    },
    onHideInModal (options) {
    },
    test (event) {
      this.appendSelect(event.target)
    },
    appendSelect (elem) {
      let $sel = window.$(elem)
      while (true) {
        let s = $sel.next()
        if (s[0]) {
          s.remove()
        } else {
          break
        }
      }
      let $newSel = $sel.clone()
      $newSel.empty().change((evt) => {
        this.appendSelect(evt.target)
      })
      let reqdata = {parent_addr_id: $sel.val(), page_index: 1, page_size: 500}
      http.post('addr.pageAddr', reqdata, {}, (data) => {
        $newSel.append(window.$('<option value=""> - </option>'))
        for (let addr of data.content) {
          $newSel.append(window.$('<option value="' + addr.addr_id + '">' + addr.description + '</option>'))
        }
        if (data.content.length > 0) {
          $sel.parent().append($newSel)
        }
      }, () => {})
    },
    discard () {
      window.$('.addr-span').show()
      window.$('#btn-edit').show()
      window.$('#btn-ctrl').hide()
      window.$('#select-input').hide()
      window.$('#new-addr-span').html('')
    },
    ensure () {
      let newTxt = ''
      let labels = []
      window.$('.your-selector').each((i, sel) => {
        labels.push(window.$(sel).find('option:selected').text())
      })
      newTxt = labels.join('-')
      window.$('.addr-span').hide()
      window.$('#btn-edit').show()
      window.$('#btn-ctrl').hide()
      window.$('#select-input').hide()
      window.$('#new-addr-span').html(newTxt)
      let $your = window.$('select.your-selector').last()
      if (!$your.val()) {
        this.addrId = $your.prev().val()
      } else {
        this.addrId = $your.val()
      }
    },
    addrLabel (addrs) {
      console.log(addrs)
      if (!addrs) {
        return ''
      }
      let lables = []
      for (let addr of addrs) {
        lables.push(addr.description)
      }
      return lables.join('-')
    },
    ...commonMethods
  },
  computed: {
    createTimeStr () {
      return this.dtFormat(this.createTime, 'yyyy-MM-DD HH:mm')
    }
  }
}
</script>
<style scoped>
.your-selector {
  display: inline;
  max-width: 120px;
}
.table tr td,th {
  text-align: center;
}
.table tr th {
  background: #eee;
}
</style>



// WEBPACK FOOTER //
// LiftDetail.vue?5b6524b0